import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import global from '../../../common/utility/global';
import CustomTable from '../../../components/CustomTable';
import { CLAIM } from '../../../common/types/parametroType';
import auth from '../../../common/utility/auth';

const REGISTRADO = 1;
const EMITIDO = 2;
const RECHAZADO = 3;
const ANULADO = 4;

export default function ResultList(props) {

    const flagClaim = props.claim ?? false;

    const renderColor = (row) => {
        if (row.idComprobanteEstado === REGISTRADO)
            return 'blue';
        if (row.idComprobanteEstado === EMITIDO)
            return 'green';
        if (row.idComprobanteEstado === RECHAZADO)
            return 'orange';
        if (row.idComprobanteEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            className={'table-venta'}
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="eye"
                                    size={"small"}
                                    loading={props.loadingVer}
                                    disabled={row.idComprobanteEstado === REGISTRADO ? true : false}
                                    onClick={() => props.onView(row)}
                                />
                            </Tooltip>
                            {(props.onBtnCopy == 2 || props.onBtnCopy == 4) ? (

                                <Tooltip placement="top" title="Copiar">
                                    <Button
                                        type="primary"
                                        icon="copy"
                                        size={"small"}
                                        disabled={(row.flagRegularizacion || row.flagCredito) ? true : false}
                                        loading={props.loadingCopy}
                                        onClick={() => props.onCopy(row)}
                                    />
                                </Tooltip>
                            ) : null}



                            <Tooltip placement="top" title="CDR">
                                <Button
                                    type="primary"
                                    icon="file-text"
                                    size={"small"}
                                    disabled={row.idComprobanteEstado !== REGISTRADO ? false : true}
                                    onClick={() => props.onCdr(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Enviar correo">
                                <Button
                                    type="primary"
                                    icon="mail"
                                    size={"small"}
                                    disabled={row.idComprobanteEstado !== REGISTRADO ? false : true}
                                    loading={props.loadingCorreo}
                                    onClick={() => props.onCorreo(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Anular">
                                <Button
                                    type="danger"
                                    icon="close"
                                    size={"small"}
                                    disabled={row.flagCajaCierre ? true : (row.idComprobanteEstado === EMITIDO ? false : true)}
                                    onClick={() => props.onAnular(row)}
                                />
                            </Tooltip>

                            {(row.flagCajaCierre) ? (

                                <Tooltip placement="top" title="Editar">
                                    <Button
                                        type="primary"
                                        icon="edit"
                                        size={"small"}
                                        loading={props.loadingEdit}
                                        disabled={true}
                                        onClick={() => props.onEdit(row)}
                                    />
                                </Tooltip>


                            ) :
                                <Tooltip placement="top" title="Editar">
                                    <Button
                                        type="primary"
                                        icon="edit"
                                        size={"small"}
                                        loading={props.loadingEdit}
                                        disabled={row.flagCredito ? true : (row.idComprobanteEstado === REGISTRADO) ? row.flagResumen ? true : false : true}
                                        onClick={() => props.onEdit(row)}
                                    />
                                </Tooltip>
                            }


                            {(row.flagResumen) ? (

                                <Tooltip placement="top" title="Emitir">
                                    <Button
                                        type="success"
                                        size={"small"}
                                        loading={props.loadingEmitir}
                                        style={{ paddingLeft: "4px", paddingRight: "4px" }}
                                        disabled={true}
                                        onClick={() => props.onEmitir(row)}
                                    >
                                        <img
                                            src={require(`../../../assets/images/send-block.png`)}
                                            style={{ height: "14px", marginBottom: '3px' }} alt="icon" />
                                    </Button>
                                </Tooltip>


                            ) :
                                <Tooltip placement="top" title="Emitir">
                                    <Button
                                        type="success"
                                        size={"small"}
                                        loading={props.loadingEmitir}
                                        style={{ paddingLeft: "4px", paddingRight: "4px" }}
                                        disabled={row.idComprobanteEstado === REGISTRADO ? false : true}
                                        onClick={() => props.onEmitir(row)}
                                    >
                                        <img
                                            src={require(`../../../assets/images/send${row.idComprobanteEstado === REGISTRADO ? "" : "-block"}.png`)}
                                            style={{ height: "14px", marginBottom: '3px' }} alt="icon" />
                                    </Button>
                                </Tooltip>
                            }


                            <Tooltip placement="top" title="Imprimir">
                                <Button
                                    loading={props.loadingImprimir}
                                    type="primary"
                                    icon="printer"
                                    size={"small"}
                                    onClick={() => props.onImprimir(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Número Orden',
                    dataIndex: 'nroOrden',
                    key: 'nroOrden',
                    sorter: true,
                    className: flagClaim ? 'show' : 'hide'
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoCliente',
                    key: 'tipoDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Número Documento',
                    dataIndex: 'numeroDocumentoCliente',
                    key: 'numeroDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Cliente',
                    dataIndex: 'razonSocialCliente',
                    key: 'razonSocialCliente',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Forma Pago',
                    dataIndex: 'formaPago',
                    key: 'formaPago',
                    sorter: true
                },
                {
                    title: 'Proyecto',
                    dataIndex: 'proyecto',
                    key: 'proyecto',
                    sorter: true
                },
                {
                    title: 'Vendedor',
                    dataIndex: 'vendedor',
                    key: 'vendedor',
                    sorter: true
                },
                (props.onTipoFilter == "2" ?
                    {
                        title: 'Motivo',
                        dataIndex: 'motivo',
                        key: 'motivo',
                        sorter: true
                    } :
                    {}
                ),
                {
                    title: 'Moneda',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },
                {
                    title: 'Sub Total',
                    dataIndex: 'subTotal',
                    key: 'subTotal',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(2))}</span>
                    )
                },
                {
                    title: 'Igv',
                    dataIndex: 'igv',
                    key: 'igv',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(2))}</span>
                    )
                },
                {
                    title: 'Total',
                    dataIndex: 'total',
                    key: 'total',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(2))}</span>
                    )
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreComprobanteEstado',
                    key: 'nombreComprobanteEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}